module.exports = __webpack_public_path__ + "img/logo-coder.de73ae73.svg";